module.exports = __webpack_public_path__ + "img/barber-2.af814fc9.svg";